import React from "react";
import TextToggle from "../../../shared/TextToggle";

const AiToolToggle = ({
  publicDomain,
  alignment,
  leftContent,
  rightContent
}) => {
  const toggleBanners = () => {
    const switchBanners = document.querySelectorAll(
      "#poem-switch-to-ai, #poem-switch-to-content"
    );

    switchBanners.forEach((banner) => {
      banner.classList.toggle("tw-hidden");
    });
  };

  const handleToggle = () => {
    const aiTool = document.querySelector(".poem-ai-tool");
    const content = document.querySelector(".poem-guide-content");

    aiTool.classList.toggle("tw-hidden");
    content.classList.toggle("tw-hidden");

    toggleBanners();
  };

  const handleSmallScreenClick = () => {
    const aiTool = document.querySelector(".poem-ai-tool");
    const content = document.querySelector(".poem-guide-content");

    ["tw-hidden", "md:tw-block"].forEach((cls) => {
      aiTool.classList.toggle(cls);
      content.classList.toggle(cls);
    });

    toggleBanners();
  };

  return publicDomain ? (
    <div className="ai-tool-toggle-container">
      <TextToggle
        alignment={alignment}
        leftContent={leftContent}
        rightContent={rightContent}
        onToggle={handleToggle}
      />
    </div>
  ) : (
    <div
      aria-hidden="true"
      className="lc-text-toggle empty"
      onClick={handleSmallScreenClick}
    />
  );
};

export default AiToolToggle;
